import { jsx as _jsx } from "react/jsx-runtime";
function Loading() {
    return _jsx("div", Object.assign({ className: "text-white" }, { children: "loading..." }));
}
export default Loading;
